import format from "date-fns/format";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import { ADD_TO_BASKET_URL } from "../../../api/apiRoutes";
import { setBasketItemLimited } from "../../../models/BasketItem";
import useFacility from "../../../../utils/hooks/useFacility";

export default function useCustomHooks() {
  const { post } = useApiRequest();
  const facilityIds = useFacility();

  const addGuideToBasket = async (ids: number, qnt: number) => {
    const formattedDate = format(new Date(), "yyyy-MM-dd");
    const basketItem = setBasketItemLimited(facilityIds, `0,+${ids}`, formattedDate, qnt, []);

    await post(ADD_TO_BASKET_URL, {
      ...basketItem,
    });
  };

  return {
    addGuideToBasket,
  };
}
